import { render, staticRenderFns } from "./GameLogRow.vue?vue&type=template&id=327d304a&"
import script from "./GameLogRow.vue?vue&type=script&lang=js&"
export * from "./GameLogRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports